import { Config } from '../config';
import { RefreshAuthDelegate } from '../services/HttpClient/IHttpClient';
import { shouldRefreshToken } from './isTokenExpired';

export default async function refreshTokenIfNecessary({
  accessToken,
  refreshAuthDelegate,
  refreshToken,
}: {
  accessToken: string;
  refreshAuthDelegate?: RefreshAuthDelegate;
  refreshToken?: string;
}) {
  const needsRefresh = shouldRefreshToken(accessToken, Config.tokenRefreshBufferSeconds); // 1 minuto di buffer
  if (refreshAuthDelegate && needsRefresh && refreshToken) {
    const res = await refreshAuthDelegate.refresh(refreshToken);
    const { AccessToken, RefreshToken } = res.AuthenticationResult;
    return { AccessToken, RefreshToken };
  } else {
    return { AccessToken: null, RefreshToken: null };
  }
}
